@import '../../../../../../constants/spacing.module.less';

.settings-api-banner {
  max-width: 808px;
  margin: @space-24 @space-0 @space-32;

  .settings-api-banner-button {
    margin-top: @space-4;
  }
}
